import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import SpaceTravel from "space-travel";
import {calculateAge} from "../utils/calculateAge";

const canvasStyle = {
    position: 'absolute',
    backgroundSize: 'cover',
    top: 0,
    left: 0,
    width: '101%',
    height: '100%',
    zIndex: -1,
};

export const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(150);
    const toRotate = ["web developer", "HBO student"];
    const typingSpeed = 150;
    const deletingSpeed = 75;
    const pauseAfterComplete = 2500;
    const pauseAfterDelete = 600;

    useEffect(() => {
        const spaceTravelInstance = new SpaceTravel({ canvas: document.getElementById("space-travel") });
        spaceTravelInstance.start();
    }, []);

    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta);

        return () => {
            clearInterval(ticker);
        };
    }, [text, delta, loopNum, isDeleting]);

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting
            ? fullText.substring(0, text.length - 1)
            : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if (!isDeleting && updatedText === fullText) {
            // Klaar met typen
            setIsDeleting(true);
            setDelta(pauseAfterComplete);
        } else if (isDeleting && updatedText === '') {
            // Klaar met deleten
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(pauseAfterDelete);
        } else if (isDeleting) {
            // Bezig met deleten
            setDelta(deletingSpeed);
        } else {
            // Bezig met typen
            setDelta(typingSpeed);
        }
    }

    const age = calculateAge();

    return (
        <section className="banner" id="home">
            <canvas id="space-travel" width="1363" height="878" style={canvasStyle}></canvas>
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={12} xl={7}>
                        <div>
                            <span className="tagline mb-4">Welkom op mijn portfolio!</span>
                            <h1>Jennifer Coenraad <br></br> ik ben <span className="txt-rotate" data-rotate={toRotate}><span className="wrap">{text}</span></span></h1>
                            <p>Ik ben {age} jaar en ik volg op dit moment de opleiding HBO-ICT op de Hogeschool Utrecht.</p>
                            <button><a href="#about-me">Meer over mij <ArrowRightCircle size={25} /></a></button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}